module["exports"] = [
  "Piazza",
  "Strada",
  "Via",
  "Borgo",
  "Contrada",
  "Rotonda",
  "Incrocio"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/it/address/street_suffix.js
// module id = 2426
// module chunks = 2